import { render, staticRenderFns } from "./testingTable.vue?vue&type=template&id=5cf525be&"
import script from "./testingTable.vue?vue&type=script&lang=js&"
export * from "./testingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports